
import React from "react";
import { Button } from "@/components/ui/button";
import { CalendarClock, ExternalLink, Trash2 } from "lucide-react";
import { BookingType } from "@/lib/supabase/types";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface BookingActionsProps {
  booking: BookingType;
  showActions?: boolean;
  onReschedule?: (booking: BookingType) => void;
  onDelete?: (bookingId: string, classId: string) => void;
}

const BookingActions: React.FC<BookingActionsProps> = ({
  booking,
  showActions = true,
  onReschedule,
  onDelete,
}) => {
  if (!showActions) return null;

  const handleViewBooking = (bookingId: string) => {
    window.open(`/manage?id=${bookingId}`, '_blank');
  };

  return (
    <div className="flex items-center gap-2">
      {onReschedule && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="outline"
                size="icon"
                onClick={() => onReschedule(booking)}
              >
                <CalendarClock className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Reschedule</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              onClick={() => handleViewBooking(booking.id)}
            >
              <ExternalLink className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>View</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      
      {onDelete && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="destructive"
                size="icon"
                onClick={() => onDelete(booking.id, booking.classId)}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Delete</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
};

export default BookingActions;
